import React, { Component } from 'react';
import CommentModal from "./CommentModal";
import { ReviewFileCommentDbDto } from "../common/dto/ReviewFileCommentDbDto";
import HighlightedCode from "../comp/HighlightedCode";

type Props = {
    fileName: string,
    fileContents: string,
    comments: ReviewFileCommentDbDto[],
    saveCommentCb: (ReviewFileCommentApiDto) => void
}
type State = {
    selectedComment: ReviewFileCommentDbDto | undefined
}

export default class ReviewFile extends Component<Props, State> {

    state: State = {
        selectedComment: undefined,
    }

    async componentDidMount() {
    }

    selectLine(e: OnClickEvent, lineNumber: number) {
        e.preventDefault();

        this.state.selectedComment = this.findComment(lineNumber)
            || this.createNewComment(lineNumber);

        this.setState(this.state);
    }

    createNewComment(lineNumber: number) : ReviewFileCommentDbDto {
        let comment = new ReviewFileCommentDbDto();
        comment.fileName = this.props.fileName;
        comment.lineNumber = lineNumber;
        comment.isError = true;

        return comment;
    }

    closeModal() {
        this.state.selectedComment = undefined;

        this.setState(this.state);
    }

    findComment(lineNumber: number) : ReviewFileCommentDbDto | undefined {
        const fileName = this.props.fileName;

        return this.props.comments.find(
            each => each.fileName === fileName && each.lineNumber === lineNumber);
    }

    getLineNumbers() : number[] {
        if (this.props.fileContents === '') {
            return [];
        }

        const count = this.props.fileContents.split(/\r\n|\n/).length;

        return new Array(count).fill(0).map((_, idx) => idx + 1)
    }

    getLineNumberClassName(lineNumber: number) : string {
        const comment = this.findComment(lineNumber);

        if (!comment) {
            return '';
        }

        return comment.isError
            ? 'source-row-number-link-error'
            : 'source-row-number-link-message';
    }

    render() {
        return (
            <>

            <CommentModal comment={ this.state.selectedComment as any }
                          saveCommentCb={ this.props.saveCommentCb }
                          closeCb={ () => this.closeModal() } />

            <div className="source-container">
                <div className="source-row-numbers">
                    { this.getLineNumbers().map(num =>
                        <div key={num} className={ this.getLineNumberClassName(num) } >
                            <a href=""
                               onClick={ e => this.selectLine(e, num) } >{num}</a><br />
                        </div>
                    )}
                </div>
                <div>
                    <HighlightedCode fileContents={this.props.fileContents}
                                     fileName={this.props.fileName} />
                </div>
            </div>
            </>
        );
    }
}

